import { createToaster, Toaster as ChakraToaster, Toast } from "@chakra-ui/react";
import React from "react";

type ToastValue = {
  render?: (ctx: { onClose: () => void }) => React.ReactNode;
  dismiss: () => void;
  title?: string;
  description?: string;
  type?: string;
};

export const toaster = createToaster({
  placement: "top",
  duration: 3000,
});

export const Toaster = () => (
  <ChakraToaster toaster={toaster}>
    {(value: ToastValue): React.ReactNode => {
      if (typeof value.render === "function") {
        return value.render({ onClose: value.dismiss });
      }
      const title = value.title ?? "";
      const description = value.description;
      const status = (value.type ?? "info") as "info" | "success" | "warning" | "error";
      return (
        <Toast.Root status={status} onClose={value.dismiss}>
          <Toast.Title>{title}</Toast.Title>
          {description && <Toast.Description>{description}</Toast.Description>}
          <Toast.CloseTrigger />
        </Toast.Root>
      );
    }}
  </ChakraToaster>
);
